import { render } from "./ReferentialQuestionEditor.vue?vue&type=template&id=8b80bec8&scoped=true"
import script from "./ReferentialQuestionEditor.vue?vue&type=script&lang=js"
export * from "./ReferentialQuestionEditor.vue?vue&type=script&lang=js"

import "./ReferentialQuestionEditor.vue?vue&type=style&index=0&id=8b80bec8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b80bec8"],['__file',"src/components/admin/ReferentialQuestionEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b80bec8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b80bec8', __exports__)) {
    api.reload('8b80bec8', __exports__)
  }
  
  module.hot.accept("./ReferentialQuestionEditor.vue?vue&type=template&id=8b80bec8&scoped=true", () => {
    api.rerender('8b80bec8', render)
  })

}


export default __exports__